export default __webpack_public_path__ + "9de5e9d20a06b63705df1bfab17f47ad.png";